const lang = {
  pageTitle: {
    en: 'NextPCB Stackup and Impedance Calculator',
    cn: '阻抗匹配叠层工具'
  },
  pageDesc: {
    en: "The NextPCB Stack-up and Impedance Calculator is an essential tool for estimating the required trace widths and spacings to use with NextPCB's common board stackups. Just enter the target impedance values and board parameters and click Calculate to receive recommended stack-ups and trace widths and spacings for your design.",
    cn: ''
  },
  boardBase: {
    en:'PCB Information',
    cn: '板子基本信息'
  },
  layer: {
    en: 'Layer Count',
    cn: '层数'
  },
  bheight: {
    en: 'Board Thickness',
    cn: '板厚'
  },
  outerCopper: {
    en: 'Outer Copper Weight',
    cn: '外层铜厚'
  },
  innerCopper: {
    en: 'Inner Copper Weight',
    cn: '内层铜厚'
  },
  blind: {
    en: 'Blind/Buried Vias',
    cn: '盲埋孔'
  },
  add: {
    en: 'Add',
    cn: '添加'
  },
  delete: {
    en: 'Delete',
    cn: '删除'
  },
  copy: {
    en: 'Copy',
    cn: '复制'
  },
  calculate: {
    en: 'Calculate',
    cn: '计算'
  },
  textTips: {
    en: `1. This calculator will provide the trace width and spacing required to reach the target impedance using NextPCB's commonly used stack-ups. \n
    * Simply enter the your impedance details and PCB parameters and click Calculate to show the results. \n
    * If the resulting impedance is shown in red, then the required impedance could not be calculated or differs by more than 2Ω and may not be suitable for applications requiring controlled impedance. \n
    2. Currently, the impedance calculator supports up to 10 layer boards.
    `,
    cn: `
    1、请输入您需要的阻抗值及线宽线距，系统将根据您的要求匹配出合适的叠层结构，其中线宽间距可能会有调整：\n
    * 若匹配结果的线宽、线距、到铜距离的计算值标红，有可能超出我司制程能力；\n
    * 若匹配结果的阻抗值计算结果标红，是与您要求的阻抗值相差±2ohm\n
    `
  },
  choose: {
    en: 'Select',
    cn: '选择'
  },
  seq: {
    en: 'No.',
    cn: '序号'
  },
  demand: {
    en: 'Target Impedance(Ω)',
    cn: '要求阻抗'
  },
  impLayer: {
    en: 'Signal Layer',
    cn: '阻抗层'
  },
  modeCn: {
    en: 'Impedance Model',
    cn: '阻抗模式'
  },
  top: {
    en: 'Upper Ref',
    cn: '上参考层'
  },
  bot: {
    en: 'Lower Ref',
    cn: '下参考层'
  },
  originalLineWidth: {
    en: 'Orig. Trace Width(mil)',
    cn: '原始线宽'
  },
  originalLineSpace: {
    en: 'Orig. Trace Spacing(mil)',
    cn: '原始线距'
  },
  originalCopperSpace: {
    en: 'Orig. Ground Separation(mil)',
    cn: '原到铜间距'
  },
  '单端' : {
    en: 'Single-ended',
    cn: '单端'
  },
  '差分' : {
    en: 'Differential',
    cn: '差分'
  },
  '共面单端' : {
    en: 'Coplanar Single-ended',
    cn: '共面单端'
  },
  '共面差分' : {
    en: 'Coplanar Differential',
    cn: '共面差分'
  },
  '华秋叠层结构': {
    en: 'NextPCB Stack-up',
    cn: '华秋叠层结构'
  },
  '结构': {
    en: 'Stack-up',
    cn: '结构'
  },
  lineWidth: {
    en: 'Trace Width',
    cn: '线宽'
  },
  lineSpace: {
    en: 'Trace Spacing',
    cn: '线距'
  },
  copperSpace: {
    en: 'Ground Separation',
    cn: '到铜距离'
  },
  result: {
    en: 'Result',
    cn: '计算结果'
  },
  layerName: {
    en: 'Layer',
    cn: '使用层'
  },
  graph : {
    en: 'Stack-up Diagram',
    cn: '图形'
  },
  material: {
    en: 'Material Type',
    cn: '材料'
  },
  materialProperties : {
    en: 'Specification',
    cn: '规格'
  },
  topConductorThick: {
    en: 'Laminated Thickness',
    cn: '压合厚度'
  },
  '铜箔': {
    en: 'Copper Foil',
    cn: '铜箔'
  },
  '芯板': {
    en: 'Core',
    cn: '芯板'
  },
  '含铜': {
    en: 'incl. copper',
    cn: '含铜'
  },
  '基铜': {
    en: 'Base Copper',
    cn: '基铜'
  },
  '含铜蚀刻光成光板': {
    en: 'Etched Core',
    cn: '含铜蚀刻光成光板'
  },
  '芯板': {
    en: 'Core',
    cn: '芯板'
  },
  '电镀铜': {
    en: 'Plating',
    cn: '电镀铜'
  },
  '完成铜厚': {
    en: 'Final Copper ',
    cn: '完成铜厚'
  },
  '介质厚度': {
    en: 'Thickness',
    cn: '介质厚度'
  },
  '设计值': {
    en: 'Design Value',
    cn: '设计值'
  },
  '请选择': {
    en: 'Please select'
  },
  '请输入': {
    en: 'Please enter'
  },
  '暂无数据': {
    en: 'No data'
  },
  '线宽小于3mil': {
    en: 'trace width is less than 3mil'
  },
  '线距小于3.8mil': {
    en: 'trace spacing is less than 3.8mil'
  },
  '到铜距离小于4mil': {
    en: 'ground separation is less than 4mil'
  },
  '计算结果与阻抗值相差±2ohm': {
    en: 'calculated and target impedance differ by more than 2Ω'
  },
  '当前无法计算出结果': {
    en: 'No solution could not be obtained'
  },
  '此结构计算结果不符合制作要求': {
    en: 'This stack-up is not suitable'
  },
}

export { lang as LANG }